import { CountryCode } from '@carsys/enums/country-code'
import React from 'react'
import { useSelector } from 'react-redux'
import { IRootReducerState } from 'state/rootReducer'
import { StackedIcon } from '@carsys/ui'
import DriveEtaIcon from '@mui/icons-material/DriveEta'
import EuroIcon from '@mui/icons-material/Euro'
import CurrencyPoundIcon from '@mui/icons-material/CurrencyPound'
import { SystemCssProperties } from '@mui/system'

interface Props {
  backgroundColor?: string
  fontSize?: SystemCssProperties['fontSize']
}

const VehicleSalesCurrencyIcon: React.FC<Props> = ({ backgroundColor, fontSize }) => {
  const visitorCountry = useSelector((state: IRootReducerState) => state.auth.shop.VisitorCountry)

  return visitorCountry === CountryCode.GB ? (
    <StackedIcon backgroundColor={backgroundColor} MainIcon={<DriveEtaIcon sx={{ fontSize }} />} SecondaryIcon={<CurrencyPoundIcon />} />
  ) : (
    <StackedIcon backgroundColor={backgroundColor} MainIcon={<DriveEtaIcon sx={{ fontSize }} />} SecondaryIcon={<EuroIcon />} />
  )
}

export default VehicleSalesCurrencyIcon
